import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import csidBuilder from '../../util/csidBuilder';
import getPartnerConfig from '../../util/getPartnerConfig';
import { appContext, loadAction } from '../../util/decorators';
import config from '../../config';
import VideoPlayer from '../VideoPlayer.jsx';
import VideoPlayerMessageWrapper from '../VideoPlayerMessageWrapper.jsx';
import Breakpoint from '../Breakpoint.jsx';
import loadDataSources from '../../action/loadDataSources';

const $loadAction = args => loadDataSources({
  dataSourceConfigs: {
    article: 'articleEmbed',
    videoSuggestions: 'videoSuggestions',
  },
  limit: { videoSuggestions: 7 },
  ...args,
});

const { IS_SERVER } = config;

const mapStateToProps = state => ({
  country: state.country,
  breakpoint: state.events.breakpoint,
  sovSeed: state.ads.sovSeed,
  routeParams: state.routeParams,
  article: _.get(state, 'dataSources.article[0]'),
});

@loadAction($loadAction)
@connect(mapStateToProps)
@appContext
export default class EmbedPage extends React.PureComponent {
  componentWillMount() {
    if (!IS_SERVER) {
      this.autoplay = window.location.search.substr(1, 8) === 'autoplay';
    }
  }

  render() {
    const { article, country, breakpoint, sovSeed, routeParams } = this.props;
    const hasVideo = !_.isEmpty(_.get(article, 'videos'));
    const partnerConfig = getPartnerConfig(country, routeParams.partnerId);
    let csid = '';

    if (breakpoint) csid = csidBuilder({ country, breakpoint, partner: _.get(partnerConfig, 'name') || '' });
    return (
      <div className="embed-player">
        {
          hasVideo && breakpoint > 0 &&
            <VideoPlayerMessageWrapper video={article.videos[0].data} article={article}>
              <VideoPlayer
                csid={csid}
                autoplay={this.autoplay}
                //autoplay={true}
                article={article}
                video={article.videos[0].data}
                videoElementId={`video-${article.id}`}
                country={country}
                breakpoint={breakpoint}
                embed
                sovSeed={sovSeed}
              />
            </VideoPlayerMessageWrapper>
        }
        {
          !hasVideo &&
            <p style={{ textAlign: 'center', marginTop: '2rem' }}>{this.context.app.t('EmbedPlayer.not_found')}</p>
        }
        <Breakpoint />
      </div>
    );
  }
}

EmbedPage.propTypes = {
  article: React.PropTypes.shape({
    id: React.PropTypes.string,
    videos: React.PropTypes.array,
  }),
  country: React.PropTypes.string,
  breakpoint: React.PropTypes.number,
  sovSeed: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/VideoEmbed/EmbedPage.jsx